import React from 'react';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';

import { Input } from 'redpoints-front-components/index';
import { DEBOUNCE_INTERVAL } from 'redpoints-front-common/config';

import { allIncidentsFiltersSetSearchUrl } from '../../../actions/allIncidentsActions';
import { getAllIncidentsFiltersSearchUrl } from '../../../reducers/reporting/allIncidents';
import { translate } from '../../../helpers/languageHelper';

const AllIncidentsFiltersSearchTerm = ({
  allIncidentsFiltersSetSearchUrl,
  searchTerm,
}) => {
  const handleSearchUrl = debounce(e => {
    allIncidentsFiltersSetSearchUrl({ url: e.target.value });
  }, DEBOUNCE_INTERVAL);

  return (
    <Input
      aria-label="searchTerm-input"
      label={translate('reporting.allIncidentsInternal.filters.searchTerm')}
      value={searchTerm || undefined}
      onChange={e => {
        e.persist(); // to persist the behavior of the original events!
        handleSearchUrl(e);
      }}
    />
  );
};

const mapStateToProps = state => {
  return {
    searchTerm: getAllIncidentsFiltersSearchUrl(state),
  };
};

export default connect(mapStateToProps, {
  allIncidentsFiltersSetSearchUrl,
})(AllIncidentsFiltersSearchTerm);
